module.exports = __webpack_public_path__ + "static/media/img4.683fc92c.png";